import React from 'react';

// A person's small square picture: their profile picture if they've added
// one, otherwise the first letter of their username on Frolik orange.
export default function Avatar({ user, size = 22, className = '' }) {
  const name = String(user?.username || user?.name || '?');
  const style = { width: size, height: size };
  if (user?.avatarUrl) {
    return <img className={`avatar ${className}`.trim()} src={user.avatarUrl} alt="" style={style} />;
  }
  return (
    <span
      className={`avatar avatar-initial ${className}`.trim()}
      style={{ ...style, fontSize: Math.round(size * 0.55) }}
      aria-hidden="true"
    >
      {name.charAt(0).toUpperCase()}
    </span>
  );
}
